// removed by extract-text-webpack-plugin
module.exports = {"plan-subscription":"plan-subscription","plan-subscription-price":"plan-subscription-price","plan-subscription-state-business":"plan-subscription-state-business","plan-subscription-value-content":"plan-subscription-value-content","plan-subscription-value":"plan-subscription-value","plan-subscription-note":"plan-subscription-note","button-subscription-action":"button-subscription-action"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/component/plan-subscription/plan-subscription.style.sass
// module id = Jneq
// module chunks = 3